import React, { useState } from "react";
import { Link } from "gatsby";
import dateFormat from "dateformat";
import "./PropertyCard.scss"
import ImageModule from "../../modules/image_module";
import { propertyDetailUrl, GetPrice } from "../../common/utils/property_utils";
import SearchResultsImagePopup from "../SalesCard/SearchResultsImagePopup"
import { SaveItem } from "@starberry/myaccount-website-utils"
import { HeartIcon } from "../../common/icons";

const FeaturesCard = (props) => {
    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const openLighboxMobile = (e, ind) => {
        e.preventDefault();
        setPhotoIndex(ind);
        setIsOpen(true);
    }

    const FeaturesList = props.FeaturesList;

    var image_url = FeaturesList?.images?.length > 0 ? FeaturesList.images[0].url : "";

    var property_url = propertyDetailUrl(FeaturesList?.department, FeaturesList?.search_type, FeaturesList?.status, FeaturesList?.slug, FeaturesList?.id);

    var currency = process.env.GATSBY_CURRENCY;
    // let processedImages = JSON.stringify({});
    // if (FeaturesList?.imagetransforms?.images_Transforms) {
    //     processedImages = FeaturesList?.imagetransforms?.images_Transforms;
    // }

    var images_filter = FeaturesList?.images?.length > 0 && FeaturesList?.images?.filter(img => img.url !== null)
    
    const ImageRenderList = ({item, imagename}) => {
        let processedImages = JSON.stringify({});
        if (item?.imagetransforms?.images_Transforms) {
            processedImages = item?.imagetransforms?.images_Transforms;
        }

        
        return (
          <ImageModule ImageSrc={images_filter.length > 0 ? images_filter[0] : ""} title={item.display_address} altText={item.display_address} imagetransforms={processedImages} renderer="srcSet" imagename={imagename} strapi_id={item.id} />                           
        )
    }
   
    return (
        <React.Fragment>
            <div className="slide-wrapper">
                <div className="slide-img img-zoom">

                    {<Link to={property_url}>
                        {/* <ImageModule ImageSrc={{ url: image_url, alternativeText: FeaturesList.display_address }} imagename={"property.images.list_view"} imagetransforms={processedImages} renderer="srcSet" strapi_id={FeaturesList.id} /> */}

                        <ImageRenderList item={FeaturesList} imagename={"property.images.list_view"} />
                    </Link>
                    }

                    {FeaturesList?.extra?.officeDepartment === "Prestige" ?
                        <span className="top-text prestige_bg">Hardisty <span className="prestige_clr">Prestige</span></span>
                        :
                        FeaturesList?.extra?.officeDepartment === "Collection" ? 
                            (
                                process.env.GATSBY_SITE_NAME === "John Shepherd" ?
                                    <span className="top-text collection_bg">John Shepherd <span className="collection_clr">Collection</span></span> 
                                : 
                                    <span className="top-text collection_bg"><span className="collection_clr">Collection</span></span> 
                            )
                            
                        : ""
                    }

                    {(FeaturesList.status !== "For Sale" && FeaturesList.status !== "To Let") ? <span className={`top-text ${FeaturesList?.officeDepartment}`}>{FeaturesList.status} </span> : ''
                    }

                    {images_filter?.length > 0 &&
                        <span className="bottom-text" onClick={(e) => openLighboxMobile(e, 0)}>
                            <i className="gallery-icon"></i>
                            <span className="text">{images_filter?.length}</span>
                        </span>
                    }
                    <SaveItem type="property" pid={FeaturesList.id}>
                        <span className="save-item">
                            <HeartIcon /><span> Save</span><span className="saved-text">d</span>
                        </span>
                    </SaveItem>
                </div>
                <div className="slide-content">
                    <span className="h5"><Link to={property_url}>{FeaturesList.title}</Link></span>

                    <div className="content">
                        {(FeaturesList?.price > 0 || FeaturesList?.price_qualifier) &&
                            <>
                                {FeaturesList.price > 0 &&
                                    <span className="highlight-text">{GetPrice(FeaturesList.price)}</span>
                                }
                                {(FeaturesList?.price_qualifier !== "Offers in the region of" && FeaturesList?.price_qualifier !== "Offers in excess of") &&
                                    <span className="sm-text">{FeaturesList.price_qualifier}</span>
                                }
                            </>
                        }
                    </div>



                    <h3><Link to={property_url}>{FeaturesList.display_address}</Link></h3>

                    <div className="icon-wrapper">

                        {parseInt(FeaturesList.bedroom) > 0 &&
                            <div className="icon-wrap">
                                <a href="javascript:;">
                                    <i className="icon-bed">
                                    </i>
                                </a>
                                <span className="count">{FeaturesList.bedroom}</span>
                            </div>
                        }


                        {parseInt(FeaturesList.bathroom) > 0 &&
                            <div className="icon-wrap">
                                <a href="javascript:;">
                                    <i className="icon-bath"></i>
                                </a>
                                <span className="count">{FeaturesList.bathroom}</span>
                            </div>
                        }

                        {/* <div className="icon-wrap">
                            <a href="javascript:;">
                                <i className="icon-parking">
                                </i>
                            </a>
                            <span className="count">Parking</span>
                        </div> */}
                    </div>

                    {FeaturesList.search_type === "lettings" && 
                        <div className="available_date">
                            {FeaturesList.available_from ? 
                                (new Date(FeaturesList.available_from).valueOf() > new Date().valueOf() 
                                ? `Available from ${dateFormat(FeaturesList.available_from, "dd/mm/yyyy")}`
                                : `Available Now`
                                )
                                : ''
                            }
                        </div>
                    }

                </div>
            </div>

            {isOpen && (images_filter && images_filter.length != 0) && (
                <SearchResultsImagePopup
                    propertyId={FeaturesList.id}
                    propertyImage={images_filter}
                    photoIndex={photoIndex}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    largeSize="720x380"
                    largeSize2="570x374"
                    img_type={"no_property"}
                />
            )}
        </React.Fragment>
    );
};

export default FeaturesCard;
